import axios from 'axios'
import { BASE_URL } from '@/global/util/constants'
import { filterMenuByNames } from '@/global/router'

const mediasMap = [
  { name: '计划管理-区分媒体-复选', value: 'checkbox', key: 'mediaType' },
  { name: '计划管理-区分媒体-单选', value: 'radio', key: 'mediaType' },
  { name: '计划管理-不区分媒体', value: 'global', key: 'mediaType' },
  { name: '广告管理-区分媒体-复选', value: 'checkbox', key: 'adType' },
  { name: '广告管理-区分媒体-单选', value: 'radio', key: 'adType' },
  { name: '广告管理-不区分媒体', value: 'global', key: 'adType' }
]

const mediasNames = mediasMap.map(v => v.name)

const state = {
  userid: '',
  taiheUsers: [],
  user: {},
  balance: {},
  menuData: [],
  mediaType: 'radio',
  adType: 'radio'
}

const getters = {
  userid: state => state.userid,
  taiheUsers: state => state.taiheUsers,
  user: state => state.user,
  balance: state => state.balance,
  menuData: state => state.menuData,
  mediaType: state => state.mediaType,
  adType: state => state.adType
}

const mutations = {
  setUserid(state, userid) {
    state.userid = userid
  },
  setTaiheUsers(state, taiheUsers) {
    state.taiheUsers = taiheUsers
  },
  setUser(state, user) {
    state.user = user
  },
  setMenuData(state, menuData) {
    state.menuData = menuData
  },
  setBalance(state, { data = {} }) {
    state.balance = {
      cost: data.today_cost,
      balance: data.balance,
      cash: data.cash_balance,
      rebate: data.rebate_balance,
      accountId: data.account_id,
      today: {
        cost: data.today_cost,
        cash: data.today_cash,
        rebate: data.today_rebate
      },
      yesterday: {
        cost: data.yesterday_cost,
        cash: data.yesterday_cash,
        rebate: data.yesterday_rebate
      }
    }
  },
  setMediaData(state, { key, value }) {
    state[key] = value
  }
}

const actions = {
  async getUser({ state, commit }, { platform, userid }) {
    return await axios.get(`${BASE_URL}/${platform}/user/${userid}`).then(res => {
      commit('setUser', res.data.data)
    })
  },
  async login({ state, commit }, { platform, data }) {
    const response = await axios.post(`${BASE_URL}/login/authenticate/${platform}`, data)
    return response.data
  },
  async logout({ state, commit }, { platform }) {
    const response = await axios.get(`${BASE_URL}/login/login-out/${platform}`)
    return response.data
  },
  async getVerifyCode() {
    const response = await axios.get(`${BASE_URL}/login/verification-code`)
    return response.data
  },
  async getBalanceData({ state, commit }, { platform, data }) {
    return await axios.post(`${BASE_URL}/${platform}/finance/balance`, data)
  },
  async getBalance({ state, commit }, { platform, data }) {
    return await axios.post(`${BASE_URL}/${platform}/finance/balance`, data).then(res => {
      commit('setBalance', res.data.data)
    })
  },
  async getMenu({ state, commit }, { platform, menuData }) {
    // 左侧菜单接口
    const { data } = await axios.get(`${BASE_URL}/login/column/${platform}`)
    if (data && data.code === 1) {
      const names = data.data.map(item => item.name)
      const filterNames = names.filter(name => mediasNames.indexOf(name) > -1)
      if (filterNames.length > 0) {
        filterNames.forEach(name => {
          const { key, value } = mediasMap.find(media => media.name === name) || {}
          commit('setMediaData', { key, value })
        })
      } else {
        commit('setMediaData', { key: 'mediaType', value: 'radio' })
        commit('setMediaData', { key: 'adType', value: 'radio' })
      }
      const filteredMenu = filterMenuByNames(menuData, names)
      commit('setMenuData', filteredMenu)
      // commit('setMenuData', menuData);
      return {
        names,
        menus: filteredMenu
      }
    }
  },
  async getStatus({ state, commit }, { platform }) {
    // 登录是否过期
    const response = await axios.get(`${BASE_URL}/login/is-expired/${platform}`)
    return response.data
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
